<template>
  <div class="h-full overflow-auto">
    <VBusHelper
      :reactOn="$constants.EVENTS.MENU.SHOW"
      :handler="
        () => {
          openPannel();
        }
      "
    />
    <DialogComponent
      ref="dialog"
      type="ui-less"
      v-slot="{ dialogVisible }"
      v-if="finishedMount"
      @closed="({source}) => source !== 'external' && hidePannel()"
    >
      <div
        class="fixed top-0 left-0 z-9999 w-full h-full md:hidden mobileMenu"
        id="menuPannel"
        :class="{
          'pointer-events-none opacity-0 duration-300': !dialogVisible,
          pannelOpened: dialogVisible
        }"
      >
        <SwipperView
          v-slot="{ position }"
          :nbTabs="2"
          :defaultTab="1"
          ref="tabsContainer"
          :loop="false"
          :autoPlay="false"
          @tabChanged="
            (index) => {
              onTabChanged(index);
            }
          "
        >
          <div class="h-full" v-if="position == 0">
            <div
              class="absolute w-full h-full -translate-x-full bg-white"
            ></div>
            <div
              class="absolute w-[150vw] h-full bg-black/40 duration-300 translate-x-[50vw]"
            ></div>
            <div
              class="absolute w-full h-full right-0 duration-300"
              @click="() => hidePannel()"
            ></div>
            <div class="w-[80%] bg-white h-full relative">
              <MenuPannelContent
                :collapsed="false"
                @navClicked="() => hidePannel()"
              />
            </div>
          </div>
        </SwipperView>
      </div>
    </DialogComponent>

    <div
      class="h-full hidden md:block desktopMenu"
      @mouseenter="hovering = true"
      @mouseleave="hovering = false"
    >
      <div
        class="h-full relative group duration-300"
        :class="hovering ? 'w-[20rem]' : 'w-24'"
        style="background-color: var(--bg-sidebar)"
      >
        <MenuPannelContent :collapsed="!hovering" @navClicked="() => {}" />
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'MenuPannel',
  components: {},
  props: {},
  data() {
    return {
      eventsIds: [],
      pannelIsVisible: false,
      hovering: false,
      finishedMount: false
    };
  },
  mounted() {
    // const id = Events.handleEvent("open_sidebar_menu", this.openPannel);
    // this.eventsIds.push(id);
    setTimeout(() => {
      this.finishedMount = true;
    }, 1000);
  },
  methods: {
    togglePannel() {
      if (this.pannelIsVisible) this.hidePannel();
      else this.openPannel();
    },
    openPannel() {
      this.$refs.tabsContainer?.slideTo(0);
    },
    onTabChanged({ position }) {
      console.log('🚀 ~ position:', position);
      if (position == 0) {
        this.$refs.dialog.show();
      } else {
        setTimeout(() => {
          this.$refs.dialog.hide();
        }, 300);
      }
    },
    hidePannel() {
      this.$refs.tabsContainer?.slideTo(1);
    }
  },
  watch: {}
});
</script>
